import { render, staticRenderFns } from "./updateTask.vue?vue&type=template&id=30a9c258&scoped=true&"
import script from "./updateTask.vue?vue&type=script&lang=js&"
export * from "./updateTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a9c258",
  null
  
)

export default component.exports